var _ = require('underscore');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var estimationDetailsModalTemplate = require('./estimationDetailsModalTemplate.hbs');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');

/**
 * The EstimationDetailsModalView serves as the modal view for displaying a estimated bill's details.
 *
 * @class EstimationDetailsModalView
 */
module.exports = ModalDialogWidget.extend({
  className: 'brec-dialog brec-dialog--big',

  template: estimationDetailsModalTemplate,

  behaviors: _.extend({}, ModalDialogWidget.prototype.behaviors, {
    appointmentSecureMessages: {
      behavior: SecureMessageDataBehavior,
      renderOnFetch: true,
      updateEvents: ['view.model:change:accountNumber'],
      ids: function (cache) {
        var accountExternalId = this.view.model.get('accountNumber');
        if (_.isUndefined(accountExternalId)) {
          return [];
        }
        var criteria = {
          isPatient: true,
          appointmentCriteria: {
            externalAppointmentCriteria: {
              accountNumbers: [accountExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: {property: 'behaviors.appointmentSecureMessages.data:appointmentDTO.externalAppointment.type'}
    }
  }),

  prepareFields: {
    insuranceEstimation: function() {
      var jsonModel = this.model.toJSON();
      return {
        'data': jsonModel
      };
    },
    negativeInsuranceAdjustment: function() {
      return this.model.getNegativeInsuranceAdjustment();
    },
    negativeInsurancePayment: function() {
      return this.model.getNegativeInsurancePayment();
    }
  }
});
